<!-- template output -->

<div class="gsm-upload-progress mat-typography" [ngClass]="condensed ? 'condensed' : []">
  <!-- ! multiple component layouts -->

  <ng-container *ngIf="!!fileName">
    <div class="horizontal-container">
      <div class="name shrink" [matTooltip]="condensed ? formattedProgressInfo : fileName">{{ fileName }}</div>
      <ng-container *ngTemplateOutlet="cancelButton"></ng-container>
    </div>
    <mat-progress-bar [value]="percent"></mat-progress-bar>
    <div class="horizontal-container align-content-right mat-caption" *ngIf="!condensed">
      <ng-container *ngTemplateOutlet="progressInfo"></ng-container>
    </div>
  </ng-container>

  <ng-container *ngIf="!fileName">
    <div class="horizontal-container">
      <ng-container *ngTemplateOutlet="progressInfo"></ng-container>
      <ng-container *ngTemplateOutlet="cancelButton"></ng-container>
    </div>
    <mat-progress-bar [value]="percent"></mat-progress-bar>
  </ng-container>
</div>

<!-- template parts for injection -->

<ng-template #cancelButton>
  <button *ngIf="!condensed" class="cancel-btn" mat-button (click)="cancelEvent.emit()">
    <mat-icon>cancel</mat-icon>
    <span class="label">Abbrechen</span>
  </button>
  <button *ngIf="!!condensed" mat-icon-button (click)="cancelEvent.emit()">
    <mat-icon>cancel</mat-icon>
  </button>
</ng-template>

<ng-template #progressInfo>
  <div class="status shrink" [matTooltip]="formattedProgressInfo">
    {{ progressInfo }}
  </div>
</ng-template>
